import { render } from "./helpCard.vue?vue&type=template&id=08835552"
import script from "./helpCard.vue?vue&type=script&lang=js"
export * from "./helpCard.vue?vue&type=script&lang=js"

import "./helpCard.vue?vue&type=style&index=0&id=08835552&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__